import React, {
  // MouseEventHandler,
  ReactNode,
  useEffect,
  useState,
} from "react";
import { createPortal } from "react-dom";
import { RemoveScroll } from "react-remove-scroll";
import {
  DialogSteps,
  useDialogStepsContext,
} from "../../contexts/DialogStepsContext";
import useMediaQuery from "../../hooks/useMediaQuery";
import Flex from "../Flex";
import { CloseIcon } from "../Icon/icons/Close";
import { LeftArrowIcon } from "../Icon/icons/LeftArrow";
import * as SC from "./Dialog.styles";

// const stopPropagation: MouseEventHandler<unknown> = (event) =>
//   event.stopPropagation();

interface DialogProps {
  open: boolean;
  onClose: () => void;
  onMountAutoFocus?: (event: Event) => void;
  children: ReactNode;
}

export const Dialog = ({
  children,
  onClose,
  open,
}: DialogProps): JSX.Element => {
  const { currentStep, setCurrentStep } = useDialogStepsContext();
  const isMobile = useMediaQuery("(max-width: 600px)");

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) =>
      open && event.key === "Escape" && onClose();

    document.addEventListener("keydown", handleEscape);

    return () => document.removeEventListener("keydown", handleEscape);
  }, [open, onClose]);

  const [bodyScrollable, setBodyScrollable] = useState(true);
  useEffect(() => {
    setBodyScrollable(
      getComputedStyle(window.document.body).overflow !== "hidden"
    );
  }, []);

  return createPortal(
    <SC.DialogBackdrop open={open}>
      <RemoveScroll
        enabled={bodyScrollable}
        style={{
          width: isMobile ? "100%" : "auto",
          height: isMobile ? "100%" : "auto",
        }}
      >
        <SC.DialogContainer>
          <Flex width="100%" height="55px" align="start" justify="between">
            {/* Left Arrow will be available just for the FAQ page */}
            {currentStep === DialogSteps.FAQ ? (
              <LeftArrowIcon
                size={20}
                onClick={() => setCurrentStep(DialogSteps.ONBOARDING)}
              />
            ) : (
              <div />
            )}
            <CloseIcon size={15} onClick={onClose} />
          </Flex>
          {children}
        </SC.DialogContainer>
      </RemoveScroll>
    </SC.DialogBackdrop>,
    document.body
  );
};
